import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getContactInstrument } from 'services/ContactService'
import { ContactsRequest } from 'types/contacts'
import { withPaginationPaging } from 'utils/pagination'

export const useContactInstrumentQuery = ({
  size = 10,
  page = 0,
  searchQuery,
  contactId,
}: ContactsRequest) => {
  return useQuery({
    queryKey: reactQueryKeys.contactInstruments({
      ...(size && { size }),
      ...(page && { page }),
      ...(searchQuery && { q: searchQuery }),
    }),
    queryFn: () => getContactInstrument({ size, page, searchQuery, contactId }),
    select: res => withPaginationPaging(res),
    enabled: !!contactId,
  })
}
